import { render, staticRenderFns } from "./cg-header.vue?vue&type=template&id=19e4be20&scoped=true"
import script from "./cg-header.vue?vue&type=script&lang=js"
export * from "./cg-header.vue?vue&type=script&lang=js"
import style0 from "./cg-header.vue?vue&type=style&index=0&id=19e4be20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e4be20",
  null
  
)

export default component.exports